export enum FSMPlan {
  NO_PLAN = 'NO_PLAN',
  FREE = 'FREE_PLAN',
  PAID = 'PAID_PLAN',
  CANCELLED = 'CANCELLED_PLAN',
  TRIAL = 'TRIAL_PLAN'
}

export enum FSMPlanStatus {
  ACTIVE = 'ACTIVE',
  TRIAL = 'TRIAL',
  INACTIVE = 'INACTIVE',
  PAST_DUE = 'PAST_DUE',
  CANCELED = 'CANCELED',
  PAUSED = 'PAUSED',
  RENEWED = 'RENEWED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  SYSTEM_DOWNGRADE = 'SYSTEM_DOWNGRADE',
  TRIAL_ENDED = 'TRIAL_ENDED'
}

export const FSM_ACTIVE_PLAN_STATES = [FSMPlan.PAID, FSMPlan.CANCELLED, FSMPlan.TRIAL];
